import React, { useMemo } from "react";

import { Redirect, Route, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/Auth";
import PrivateLayout from "../components/common/Layout/PrivateLayout";

const PrivateRoute = ({
  component: Component,
  layout: Layout,
  name,
  from,
  internal = false,
  platRoute = false,
  oaRoute = false,
  emeraldRoute = false,
  wealthRoute = false,
  cryptoRoute = false,
  aiAlertsRoute = false,
  ...rest
}) => {
  const {
    userData,
    authUser,
    authToken,
    isUserBasic,
    tierLevel,
    loading,
    hasPlatinumProgram,
    hasOptionsAcademy,
    canSeeInternal,
    hasEmerald,
    hasWealthSeriesAtlas,
    hasWealthSeriesCore,
    hasWealthSeriesTitan,
    hasWealthSeriesEverest,
    hasWealthSeriesLite,
    hasWealthSeriesAtlasAuto,
    hasWealthSeriesTitanAuto,
    hasWealthSeriesEverestAuto,
    hasCryptoObsidian,
    hasAiOptionsAlertsNeural,
  } = useAuth();
  const location = useLocation();
  return useMemo(() => {
    if (userData?.userSettings?.deactivatedAccount) {
      return (
        <Route
          {...rest}
          render={(props) => (
            <Redirect
              to={{
                pathname: "/deleted-account",
                state: { from: props.location },
              }}
            />
          )}
        />
      );
    }
    // if it is an internal page and the user CANT see internal pages and user data is not loading - kick em out
    if (
      (internal && !canSeeInternal && !loading) ||
      (platRoute && !hasPlatinumProgram && !loading) ||
      (oaRoute && !hasOptionsAcademy && !loading) ||
      (emeraldRoute && !hasEmerald && !loading) ||
      (wealthRoute &&
        location.pathname.includes("everest") &&
        !hasWealthSeriesEverest &&
        !hasWealthSeriesEverestAuto &&
        !loading) ||
      (wealthRoute &&
        location.pathname.includes("atlas") &&
        !hasWealthSeriesAtlas &&
        !hasWealthSeriesAtlasAuto &&
        !loading) ||
      (wealthRoute &&
        location.pathname.includes("titan") &&
        !hasWealthSeriesTitan &&
        !hasWealthSeriesTitanAuto &&
        !loading) ||
      (wealthRoute &&
        location.pathname.includes("lite") &&
        !hasWealthSeriesLite &&
        !loading) ||
      (wealthRoute &&
        location.pathname.includes("core") &&
        !hasWealthSeriesCore &&
        !loading) ||
      (cryptoRoute && !hasCryptoObsidian && !loading) ||
      (aiAlertsRoute && !hasAiOptionsAlertsNeural && !loading)
    ) {
      return (
        <Route
          {...rest}
          render={(props) => (
            <Redirect
              to={{
                pathname: "/signout",
                state: { from: props.location },
              }}
            />
          )}
        />
      );
    }
    return (
      <Route
        {...rest}
        render={(props) =>
          authUser && authToken && isUserBasic ? (
            name !== "signOut" ? (
              <></>
            ) : (
              <>
                {rest.customLayout ? (
                  <Layout {...rest} name={name} from={from}>
                    <Component {...props} {...rest} />
                  </Layout>
                ) : (
                  <PrivateLayout {...rest} name={name} from={from}>
                    <Component {...props} {...rest} />
                  </PrivateLayout>
                )}
              </>
            )
          ) : authUser && authToken ? (
            <>
              {rest.customLayout ? (
                <Layout {...rest} name={name} from={from}>
                  <Component {...props} {...rest} />
                </Layout>
              ) : (
                <PrivateLayout {...rest} name={name} from={from}>
                  <Component {...props} {...rest} />
                </PrivateLayout>
              )}
            </>
          ) : (
            <Redirect
              to={{
                pathname: "/signin",
                state: { from: props.location },
              }}
            />
          )
        }
      />
    );
  }, [
    authUser,
    Component,
    location.pathname,
    loading,
    tierLevel,
    hasEmerald,
    userData?.userSettings?.deactivatedAccount,
  ]);
};

export default PrivateRoute;
